import { ImageFile } from "@/utils/types/types";
import { Badge, Box, Flex, Text, rem } from "@mantine/core";
import { IconCircleArrowRight, IconCircleX } from "@tabler/icons-react";

type ImageBoxProps = {
  image: ImageFile;
  onSelect: (image: ImageFile) => void;
  onDelete: (image: ImageFile) => void;
};

export const ImageBox = ({ image, onSelect, onDelete }: ImageBoxProps) => {
  return (
    <Box p={rem(8)} style={{ position: "relative" }} w="100%">
      <div
        className="group/image relative h-auto w-full cursor-pointer"
        onClick={e => {
          e.stopPropagation();
          onSelect(image);
        }}
      >
        <img src={image.thumbnailUrl || image.url} className="h-auto w-full" />
        <div className="invisible absolute inset-0 grid place-items-center content-center bg-black bg-opacity-35 leading-none text-white group-hover/image:visible">
          <IconCircleArrowRight className="size-[24px] stroke-[2px]" />
          <p className="font-bold">Continue</p>
          <p className="text-[14px]">to next step</p>
        </div>
      </div>
      <Badge
        color="dark"
        onClick={() => onDelete(image)}
        p={0}
        radius="xl"
        size="sm"
        style={{
          cursor: "pointer",
          height: "24px",
          position: "absolute",
          right: 0,
          top: 0,
          width: "24px",
        }}
        variant="white"
      >
        <Flex align="center" justify="center">
          <IconCircleX stroke={1.66} />
        </Flex>
      </Badge>
      <Text py={rem(4)} size={rem(12)} truncate>
        {image.name}
      </Text>
    </Box>
  );
};
